import * as React from "react"
import { Link } from "gatsby"

const MainNavLink = ({ title, to }) => {
  return (
    <li>
      <Link
        children
        className={
          "text-sm font-normal text-white hover:text-blue uppercase tracking-widest transition duration-500 ease-in-out"
        }
        to={to}
      >
        {title}
      </Link>
    </li>
  )
}

export default MainNavLink
